import type { VideoRelease, VideoReleaseEntry } from './types.ts';
import { MONITORING_RELEASE } from './monitoring.ts';
import { VIRTUAL_APPOINTMENTS_RELEASE } from './virtualAppointments.ts';

// Newest first; the first version (semver, bumped by hand) shows once to every staff user.
// Versions are compared for equality only, so any new id reads as unseen.
export const ADMIN_RELEASES: readonly [VideoReleaseEntry, ...VideoReleaseEntry[]] = [
    { version: '1.1.0', date: '2026-10-10', release: MONITORING_RELEASE },
    { version: '1.0.0', date: '2026-10-04', release: VIRTUAL_APPOINTMENTS_RELEASE }
];

const [NEWEST_RELEASE] = ADMIN_RELEASES;

export const CURRENT_RELEASE: string = NEWEST_RELEASE.version;

export const CURRENT_ADMIN_RELEASE: VideoRelease = NEWEST_RELEASE.release;
